import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import { Modal, Button, Grid, Row, Col, Breadcrumb, Thumbnail, Carousel} from 'react-bootstrap';
import ReactDOM from 'react-dom'

// images

import banner1 from './images/banner1.jpg';
import InfoJumb1 from './images/jumbo1.png';


class Ebs extends Component {
  constructor(props, context) {
    super(props, context);


    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.state = {
      show: false,
      product: 'Default',
      listItemsProperties: '',
      listItemsPropertiesExt: '',
      sizeType: '',
      sizeData: '',
      sizeMeas: '',
      pdfLink: '',
      pdfAlias: '',
      image: '',
      carousel: ''
    };




  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }



  handleUpdate(product, carousel) {
    var productTmp = JSON.parse(product);
    var productArr = productTmp[0].prop;
    var carouselArr = JSON.parse(carousel)[0].item;
    this.setState({listItemsProperties: productArr.map((elementEx) =>
      <li key={elementEx.data}>{elementEx.data}</li>
    )});
    this.setState({carousel: carouselArr.map((elementCarousel) =>
      <Carousel.Item>
        <img className="productsDetailCarousel" src={"/supplier/ebs/maschinen/"+elementCarousel.$.img} id={this.state.product + "_img_" + elementCarousel.$.id} alt={elementCarousel.$.alt}/>
        <Carousel.Caption>
          <h3>{elementCarousel.$.cap}</h3>
        </Carousel.Caption>
      </Carousel.Item>
    )});
  }

  render() {
    var data;
      var builtTmp;
      var parseString = require('xml2js').parseString;

        fetch('/supplier/ebs/produkte/data_strahlen.xml')
        .then((r) => r.text())
        .then(text  => {
          parseString(text, function (err, result) {
              data=result;
              var tmpOV = JSON.parse(JSON.stringify(result));
              data= tmpOV.maschinen.maschine;
              builtTmp = data.map((element) =>
              <Col xs={12} md={4}>
                <Thumbnail className="thumbNail" src={`/supplier/ebs/maschinen/${element.Image}`} alt={element.Name}>
                  <h3>{element.Name}</h3>
                  <p>{element.sizeType}</p>
                  <p>{element.sizeMeas}</p>
                  <p>{element.sizeData}</p>
                  <br/>
                  <Button bsStyle="primary" onClick={() => {
                    this.setState({product: element.Name, sizeData: element.sizeData, sizeMeas: element.sizeMeas, sizeType: element.sizeType, pdfLink: element.pdfLink, pdfAlias: element.pdfAlias, image: `/supplier/Ebs/maschinen/${element.Image}`});
                    this.handleUpdate(JSON.stringify(element.properties), JSON.stringify(element.carousel));
                    this.handleShow();
                  }}>Mehr Informationen</Button>
                  <br/>
                </Thumbnail>
              </Col>

              );

            }.bind(this));
            this.builtElement = ReactDOM.render(builtTmp, document.getElementById('productsRoot'));
        });
    return (
      <div className='container-fluid'>

        <div className="supMain">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>EB.S.</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt=""/>
        </div>
        <div className="supMainText">
          <h1>EB.S.</h1>
            <Grid className="supMainInfo">
              <Row>
                <Col xsHidden smHidden md={7}>
                    <img  src={InfoJumb1}  alt=""  height="100%"/>
                  </Col>
                <Col xsHidden md={5}>
                  <h4>EB.Strahlkabinen sind speziell für den Werkzeug- & Formenbau konstruiert. Die Technologie der Kabinen verspricht eine genaue und wiederholbare Bearbeitung erodierter Oberflächen sowie die Reinigung von Werkzeugen. Die ergonomische Form und der große Arbeitsbereich von 600 x 450 mm gewährleisten eine komfortable und präzise Bearbeitung der Werkstücke.
                </h4>
                </Col>
                <Col xs={12}  smHidden mdHidden lgHidden>
                  <h4>EB.Strahlkabinen sind speziell für den Werkzeug- & Formenbau konstruiert. Die Technologie der Kabinen verspricht eine genaue und wiederholbare Bearbeitung erodierter Oberflächen sowie die Reinigung von Werkzeugen. Die ergonomische Form und der große Arbeitsbereich von 600 x 450 mm gewährleisten eine komfortable und präzise Bearbeitung der Werkstücke.
                </h4>
                </Col>
                <Col xs={12} md={{ span: 7, offset: 2 }}>
                  <Button className="supMainButtonWebPage" variant="light" href="https://ebs-gmbh.com/produkte/strahlen/" target="_blank">Hersteller Homepage</Button>
                </Col>
              </Row>
            </Grid>
            <br/>
        </div>



        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              {/* <Col xsHidden  sm={4} md={2}>

                <h5>Langjährige Erfahrung und Expertise</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Bewährte Maschinenkonzepte</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Individuelle Lösungen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Höchste Qualitätsstandards</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Partnerschaftliche Zusammenarbeit</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Umfassender Service</h5>
              </Col> */}

            </Row>
            <br/>
            <Row className="show-grid">
              {/* <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Langjährige Erfahrung und Expertise</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Bewährte Maschinenkonzepte</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Höchste Qualitätsstandards</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Umfassender Service</h5>
              </Col> */}


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>
          <br/>
          <center>
          <h1>Produkte</h1>
          </center>
          <br/><br/>
          <Grid className="gridUp" id="productsRoot">
          </Grid>
          <br/>
        </section>
        <Modal show={this.state.show} onHide={this.handleClose} >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.product}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Carousel className="productsDetailCarousel">{this.state.carousel}</Carousel>
            <br/>
            <h5>{this.state.sizeType}</h5>
            <p>{this.state.sizeData} &nbsp; {this.state.sizeMeas}</p>
            <br/>
            <h5>Eigenschaften</h5>
            <ul className='unordEnumBase'>{this.state.listItemsProperties}</ul>
            <br/>
            <h5>Download</h5>
            <a href={this.state.pdfLink}>{this.state.pdfAlias}</a>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Schließen</Button>
          </Modal.Footer>
        </Modal>
        </div>
    );
  }
}

export default Ebs;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/ebs/mainPageSup.js